import Home from './components/Home';
import NavBar from './components/NavBar';
import React from 'react';
import About from './components/About';
import Experience from './components/Experience';
import Contact from './components/Contact';
import SocialLinks from './components/SocialLinks';
import Portfolio from './components/Portfolio';


function App() {
  return (
    <>
      <NavBar />
      <Home />
      <About/>
      <Portfolio/>
      <Experience/>
      <Contact/>
      <SocialLinks/>
    </>
  );
}

export default App;
